import React, { Component } from 'react';
import Square from './Square.js';

class Board extends Component {
    
  renderSquare(i) {
    return (
      <Square 
        value={this.props.squares[i]} 
        onClick={() => this.props.onClick(i)}
        classRef={i}
      />
    );
  }

  render() {
    return (
      <div className="board">
        <div className="board-container">
        <div className="board-row">
          {this.renderSquare(0)}
          {this.renderSquare(1)}
          {this.renderSquare(2)}
        </div>
        <div className="board-row">
          {this.renderSquare(3)}
          {this.renderSquare(4)}
          {this.renderSquare(5)}
        </div>
        <div className="board-row">
          {this.renderSquare(6)}
          {this.renderSquare(7)}
          {this.renderSquare(8)}
        </div>
        </div>
      </div>
    );
  }
}

export default Board;


// WEBPACK FOOTER //
// ./src/components/Board.js